// 32px ruler + 28px ruler end-cap + 16px workspace buffer on each side.
const FIT_CHROME_PX = 92
const MIN_FIT_ZOOM = 0.025
const MAX_FIT_ZOOM = 1.0

function clampFitZoom(value) {
  return Math.min(MAX_FIT_ZOOM, Math.max(MIN_FIT_ZOOM, value))
}

export function calculateFitZoom({ availableWidth, availableHeight, canvasWidth, canvasHeight }) {
  const widthFit = (availableWidth - FIT_CHROME_PX) / canvasWidth
  const heightFit = (availableHeight - FIT_CHROME_PX) / canvasHeight
  const candidates = [widthFit, heightFit].filter(value => Number.isFinite(value) && value > 0)

  if (candidates.length === 0) return 1.0
  return clampFitZoom(Math.min(...candidates))
}
